module.exports = __webpack_public_path__ + "media/images/ninestars/portfolio/portfolio-details-2-387ed8ce9a6967b5c964a4317e06e4d6.jpg";